import { App } from '@capacitor/app'
import { getActivePinia } from 'pinia'
import type { Router } from 'vue-router'
import { useDialogsStore } from '@/store/dialogs'
import { isNativeApp } from './native-platform'
import { goBackOrElse } from './navigation-history'

function closeOpenDialog(): boolean {
  if (!getActivePinia()) return false

  return useDialogsStore().closeDialog()
}

export function registerHardwareBackButton(router: Router) {
  if (!isNativeApp()) return

  App.addListener('backButton', () => {
    if (closeOpenDialog()) return

    goBackOrElse(router, () => App.minimizeApp())
  })
}
